import React from "react";
import { Button, Card, Row, Col } from "antd";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Title from "antd/lib/typography/Title";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

type Props = {
  title: string;
  actionText?: string;
  actionLink?: string;
  icon?: IconProp;
  children?: React.ReactNode;
};

const ProfileCardBase: React.FC<Props> = ({ title, children, actionText, actionLink, icon }) => {
  return (
    <Card style={{ height: "100%" }}>
      <Row align="middle" style={{ height: "100%" }}>
        <Col
          span={18}
          style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}
        >
          <Title level={4}>{title}</Title>
          <div>{children}</div>
          <br />
          {actionText && actionLink && (
            <Col>
              <Button type="primary" style={{ textAlign: "left" }}>
                <Link to={actionLink}>{actionText}</Link>
              </Button>
            </Col>
          )}
        </Col>
        {icon && (
          <Col span={6} style={{ textAlign: "center" }}>
            <FontAwesomeIcon icon={icon} size="3x" />
          </Col>
        )}
      </Row>
    </Card>
  );
};

export default ProfileCardBase; // Endret til å være en default eksport
